import CNPJ from "./cnpj";
import CPF from "./cpf";

function validate(document) {
  return CPF.validate(document) || CNPJ.validate(document);
}

export default {
  validate
};



// WEBPACK FOOTER //
// ./src/utils/validators/documents.js